export const select = (id: string) => {
	const el = document.getElementById(id) as HTMLInputElement;
	if (!el) return;
	el.focus();
	el.select && setTimeout(() => el.select(), 25);
	return true;
};
